// extracted by mini-css-extract-plugin
export default {"productGrid":"u7-z","centerLink":"v7-z","productSection":"w7-z","item":"x7-z","ctaButton":"y7-z"};